import Vue from 'vue' // in Vue 2
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.baseURL = process.env.VUE_APP_AXIOS_BASE_URL

Vue.use(VueAxios, axios)
